(function () {
  function initSwiper(section) {
    var el = section.querySelector('.et-fv__swiper');
    if (!el || el.hasAttribute('data-et-fv-swiper')) return;
    el.setAttribute('data-et-fv-swiper', '');

    var options = {
      slidesPerView: parseFloat(el.dataset.slidesMobile) || 1.1,
      spaceBetween: 16,
      breakpoints: {
        750: { slidesPerView: 3 },
        990: { slidesPerView: parseFloat(el.dataset.slidesDesktop) || 4 }
      }
    };

    var prev = section.querySelector('.et-fv__arrow--prev');
    var next = section.querySelector('.et-fv__arrow--next');
    if (prev && next) {
      options.navigation = { prevEl: prev, nextEl: next };
    }

    var dots = section.querySelector('.et-fv__dots');
    if (dots) {
      options.pagination = { el: dots, clickable: true };
    }

    new Swiper(el, options);
  }

  /* This observer is also the lazy-loader, not just a pause switch: the cards
     render without autoplay and with preload="none" (see et-fv-card.liquid),
     so the play() here is what starts each video's download. The 250px margin
     mirrors the lazysizes expand distance the live theme uses for the same
     videos — a card begins buffering just before it scrolls or slides in,
     and pauses again once it leaves that band. */
  function initVideoObserver(section) {
    var videos = section.querySelectorAll('.et-fv__video');
    if (!videos.length || typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            video.muted = true;
            video.playsInline = true;
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '250px', threshold: 0 }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  }

  /* Variant pills + price sync + add to cart, works for cards and modal buy boxes */
  function initBuyBoxes(section) {
    section.querySelectorAll('[data-et-fv-card]').forEach(function (box) {
      var priceEl = box.querySelector('[data-et-fv-price]');
      var addBtn = box.querySelector('[data-et-fv-add]');

      box.querySelectorAll('[data-et-fv-pill]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          box.querySelectorAll('[data-et-fv-pill]').forEach(function (p) {
            p.classList.remove('is-selected');
          });
          pill.classList.add('is-selected');
          box.dataset.variantId = pill.dataset.variantId;
          if (priceEl && pill.dataset.price) priceEl.textContent = pill.dataset.price;
          if (addBtn) addBtn.disabled = pill.dataset.available === 'false';
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          addToCart(box.dataset.variantId, addBtn);
        });
      }
    });
  }

  function addToCart(variantId, btn) {
    var id = parseInt(variantId, 10);
    if (!id || btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        closeAllModals();
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var toggle = document.getElementById('cart-drawer-toggle');
        if (toggle) toggle.click();
      })
      .catch(function () {})
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  }

  /* Modal open/close + mute toggle */
  var lastTrigger = null;

  function openModal(modal, trigger) {
    modal.hidden = false;
    lastTrigger = trigger || null;
    document.documentElement.classList.add('et-fv-modal-open');

    var video = modal.querySelector('.et-fv__modal-video');
    var muteBtn = modal.querySelector('[data-et-fv-mute]');
    if (video) {
      video.playsInline = true;
      video.muted = false;
      if (muteBtn) muteBtn.classList.remove('is-muted');
      var playing = video.play();
      if (playing && playing.catch) {
        playing.catch(function () {
          video.muted = true;
          if (muteBtn) muteBtn.classList.add('is-muted');
          var retry = video.play();
          if (retry && retry.catch) retry.catch(function () {});
        });
      }
    }

    var close = modal.querySelector('.et-fv__modal-close');
    if (close) close.focus();
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.documentElement.classList.remove('et-fv-modal-open');
    var video = modal.querySelector('.et-fv__modal-video');
    if (video) {
      video.pause();
      video.muted = true;
    }
    var muteBtn = modal.querySelector('[data-et-fv-mute]');
    if (muteBtn) muteBtn.classList.add('is-muted');
    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  function closeAllModals() {
    document.querySelectorAll('.et-fv__modal:not([hidden])').forEach(closeModal);
  }

  function initModals(section) {
    section.querySelectorAll('[data-et-fv-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var modal = document.getElementById('et-fv-modal-' + trigger.dataset.etFvOpen);
        if (modal) openModal(modal, trigger);
      });
    });

    section.querySelectorAll('.et-fv__modal').forEach(function (modal) {
      modal.querySelectorAll('[data-et-fv-close]').forEach(function (closer) {
        closer.addEventListener('click', function () {
          closeModal(modal);
        });
      });

      var muteBtn = modal.querySelector('[data-et-fv-mute]');
      var video = modal.querySelector('.et-fv__modal-video');
      if (muteBtn && video) {
        muteBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          muteBtn.classList.toggle('is-muted', video.muted);
          muteBtn.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
        });
      }
    });
  }

  function initSection(section) {
    if (section.hasAttribute('data-et-fv-init')) return;
    section.setAttribute('data-et-fv-init', '');
    initBuyBoxes(section);
    initModals(section);
    initVideoObserver(section);
    whenSwiperReady(function () {
      initSwiper(section);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.et-fv').forEach(initSection);
  }

  function whenSwiperReady(callback) {
    if (typeof Swiper !== 'undefined') {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        callback();
      } else if (attempts > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllModals();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.et-fv')) {
      initAll(event.target);
    } else if (event.target.classList && event.target.classList.contains('et-fv')) {
      initSection(event.target);
    }
  });
})();
